import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./components/containers/App";
import { ENVIRONMENT } from "./config";
import "./index.css";
import store from "./redux/store";
import { initRewardful } from "./rewardful";

if (ENVIRONMENT === "prod") {
  initRewardful();
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
